import { NavItem } from "@/types";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { memo } from "react";
import NotificationDot from "./NotificationDot";

const IconNavItem = memo(({ item }: { item: NavItem }) => {
  const pathname = usePathname();
  const isActive = pathname === item.href;

  return (
    <Link href={item.href} prefetch={false}>
      <div className={`
        relative group w-10 h-10 rounded-xl
        flex items-center justify-center mx-auto mb-1
        transition-colors duration-150 cursor-pointer
        ${isActive ? 'bg-blue-500 text-white' : 'text-slate-400 hover:bg-white/10'}
      `}>
        <span className="shrink-0">{item.icon}</span>

        {item.hasNotification && (
          <div className="absolute top-1.5 right-1.5">
            <NotificationDot />
          </div>
        )}

        <span
          role="tooltip"
          className="
            absolute left-12 top-1/2 -translate-y-1/2
            bg-slate-800 text-white text-xs font-semibold
            px-2.5 py-1.5 rounded-lg whitespace-nowrap
            opacity-0 group-hover:opacity-100
            transition-opacity duration-150
            pointer-events-none z-50
          "
        >
          {item.label}
          <span
            aria-hidden
            className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-slate-800"
          />
        </span>
      </div>
    </Link>
  );
});

export default IconNavItem;